module.exports = __webpack_public_path__ + "static/media/torso-low-left-side.8502099c.png";